










// @TODO: `[Vuetify] Image load failed` is shown on-error, tho we can ignore it. See how to remove that logged error.
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class ContentImage extends Vue {
  @Prop({ required: true, type: String }) src!: string

  error: boolean = false

  onError() {
    this.error = true
  }

  get imgSrc(): string {
    let fallbackImage = 'solid_black_link_256x144'
    return this.error || !this.src ? this.getImgUrl(fallbackImage) : this.src
  }

  getImgUrl(pet) {
    var images = require.context('../assets/', false, /\.png$/)
    return images('./' + pet + '.png')
  }
}

